import { useFormContext, useWatch } from "react-hook-form";
import { DoraSelect } from "dora-shared/frontend";
import CreateEditShipmentData from "../CreateEditShipmentData";

type ClientContactSelectProps = {
  id: string;
  options: { label: string; value: string }[];
  customerContactId: string | null;
  onInputChange: (value: string) => void;
  placeholder: string;
};

// Watches clientContact itself so typing a contact re-renders only this
// select: a watch("clientContact") in the dialog re-rendered the whole dialog
// on every keystroke (DISPATCHER-CP / DORA-406).
const ClientContactSelect = ({
  id,
  options,
  customerContactId,
  onInputChange,
  placeholder,
}: ClientContactSelectProps) => {
  const { control } = useFormContext<CreateEditShipmentData>();
  const clientContact = useWatch({ control, name: "clientContact" });

  return (
    <DoraSelect
      id={id}
      options={options}
      value={customerContactId || clientContact}
      fullWidth
      onInputChange={(_, v) => onInputChange(v)}
      freeSolo
      placeholder={placeholder}
    />
  );
};

export default ClientContactSelect;
